import React from "react";
import PropTypes from "prop-types";
import CssBaseline from "@material-ui/core/CssBaseline";

import withStyles from "@material-ui/core/styles/withStyles";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import Checkbox from "@material-ui/core/Checkbox";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import CircularProgress from "@material-ui/core/CircularProgress";

import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider
} from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import CustomizedSnackbar from "../Snackbar/CustomizedSnackbar";
import DisclaimerDialog from "../Dialogs/DisclaimerDialog";
import SureDialog from "../Dialogs/SureDialog";
import FormDialog from "../Dialogs/FormDialog";
import Footer from "../Common/Footer";

import cardImage from "../Media/back14.jpg";

import { nationalities } from "../Variables/Nationalities";

import firebase from "firebase/app";
import "firebase/database";
import moment from "moment";
// import sendMail from "../Configs/sendMail.js";

const styles = theme => ({
  card: {
    backgroundColor: theme.palette.white,
    margin: 30,
    [theme.breakpoints.down("sm")]: {
      margin: 0
    },
    borderRadius: 10
  },
  cardContent: {
    margin: 30
  },
  textField: {
    margin: 10,
    width: 300,
    maxWidth: "90%"
  },
  textFieldFull: {
    margin: 10,
    width: "90%"
  },
  gridContainer: {},
  gridItem: {
    maxWidth: 1200
  },
  cardHeader: {
    backgroundColor: theme.palette.primary.color["100"]
  },
  redHelperText: {
    color: "red"
  },
  cardActions: {
    justifyContent: "space-between",
    padding: 20,

    [theme.breakpoints.down("xs")]: {
      flexDirection: "column-reverse",
      justifyContent: "center",
      alignItems: "center"
    }
  },
  smallButton: {
    [theme.breakpoints.down("xs")]: {
      width: "100%",
      padding: 10,
      textAlign: "center"
    }
  },
  submitButton: {
    [theme.breakpoints.down("xs")]: {
      width: "100%"
    }
  }
});

class Register extends React.Component {
  constructor() {
    super();
    this.state = {
      requiredFields: [
        "firstName",
        "surname",
        "nationality",
        "phone",
        "email",
        "idNumber",
        "gender",
        "ecName",
        "ecPhone"
      ],
      dob: moment().subtract(30, "years"),
      gender: "",
      nationality: "",
      volunteer: false,
      snackbarTrigger: false,
      snackbarVariant: "error",
      disclaimerTriggered: false,
      disclaimerAgreed: false,
      sureDialogTriggered: false,
      submmiting: false,
      submmitingComment: false
    };
  }

  handleSelectChange = name => event => {
    this.setState({
      [name]: event.target.value
    });
  };

  handleChange = event => {
    this.setState({ [event.target.id]: event.target.value });
  };

  handleDateChange = date => {
    this.setState({ dob: date });
  };

  handleCheckboxChange = event => {
    this.setState({ [event.target.value]: event.target.checked });
  };

  onSnackbarClose = () => {
    this.setState({ snackbarTrigger: false });
  };

  disclaimerTrigger = () => {
    this.setState({ disclaimerTriggered: true });
  };
  onSureClose = () => {
    this.setState({ sureDialogTriggered: false });
  };

  openContactForm = () => {
    this.setState({ contactFormTriggered: true });
  };

  onContactFormClose = (event, response) => {
    this.setState({ contactFormTriggered: false });
    if (response === "backdropClick" || !response) {
      return;
    }
    if (
      response.name === "" ||
      response.email === "" ||
      response.message === ""
    ) {
      this.triggerSnackbar("Please add your name, email and message", "error");
      return;
    }
    response.time = moment().format("YYYY-MM-DD HH:mm");
    firebase
      .database()
      .ref("comments")
      .push(response)
      .then(
        this.triggerSnackbar(
          "Message sent, you will hear from us soon",
          "success"
        )
      )
      .catch(error => {
        this.triggerSnackbar(error.message, "error");
      });
  };

  onSubmit = () => {
    var missingFields = false;
    var missing = [];
    this.state.requiredFields.forEach(key => {
      if (this.state[key] === "" || this.state[key] === undefined) {
        missingFields = true;
        missing.push(key);
      }
    });
    if (missingFields) {
      this.setState({
        snackbarMessage: "Please complete missing fields",
        snackbarTrigger: true,
        snackbarVariant: "error"
      });
    } else if (!this.state.disclaimerAgreed) {
      this.setState({
        snackbarMessage: "Please read and agree to the disclaimer",
        snackbarTrigger: true,
        snackbarVariant: "error"
      });
      firebase
        .database()
        .ref("errors")
        .push({
          issue: "Read disclaimer",
          data: { state: this.state },
          time: moment().format()
        });
    } else {
      this.setState({ submmiting: true });
      this.writeNewUser();
    }
  };

  capitalizeFirstLetter = text => {
    if (text) {
      return text
        .toLowerCase()
        .split(" ")
        .map(s => s.charAt(0).toUpperCase() + s.substring(1))
        .join(" ");
    }
  };

  writeNewUser = () => {
    const db = firebase.database();
    const bibCounterRef = db.ref("lastBibNumber");
    const usersRef = db.ref("users");
    const leagueRef = db.ref("usersLeague");

    var user = {
      firstName: this.capitalizeFirstLetter(this.state.firstName) || "",
      surname: this.capitalizeFirstLetter(this.state.surname) || "",
      phone: this.state.phone || "",
      email: this.state.email || "",
      dob: this.state.dob.format("YYYY-MM-DD") || "",
      idNumber: this.state.idNumber || "",
      gender: this.state.gender || "",
      nationality: this.state.nationality || "",
      ecName: this.state.ecName || "",
      ecPhone: this.state.ecPhone || "",
      volunteer: this.state.volunteer || "",
      timeRegistered: moment().format("YYYY-MM-DD hh:mm") || ""
    };
    var leagueData = {
      firstName: this.capitalizeFirstLetter(this.state.firstName) || "",
      surname: this.capitalizeFirstLetter(this.state.surname) || "",
      dob: this.state.dob.format("YYYY-MM-DD") || "",
      gender: this.state.gender || ""
    };

    usersRef
      .orderByChild("idNumber")
      .equalTo(user.idNumber)
      .once("value")
      .then(snapshot => {
        if (snapshot.val() === null) {
          bibCounterRef.transaction(
            bibNumber => {
              return bibNumber + 1;
            },
            (error, committed, snapshot) => {
              const bib = snapshot.val();
              user.bibNumber = bib;
              leagueData.bibNumber = bib;
              leagueRef.child(bib).set(leagueData);
              usersRef.child(bib).set(user, error => {
                if (error) {
                  this.triggerSnackbar(error.message, "error");
                  firebase
                    .database()
                    .ref("errors")
                    .push({
                      issue: "Writing to FB",
                      data: {
                        state: this.state,
                        errorMsg: error.message,
                        time: moment().format()
                      }
                    });
                } else {
                  document.getElementById("registration-form").reset();
                  this.setState({
                    firstName: "",
                    surname: "",
                    phone: "",
                    dob: moment().subtract(30, "years"),
                    idNumber: "",
                    gender: "",
                    nationality: "",
                    volunteer: "",
                    ecName: "",
                    ecPhone: "",
                    submmiting: false
                  });
                  this.triggerSure(bib);
                }
              });
            }
          );
        } else {
          this.triggerSnackbar(
            "Hi " +
              user.firstName +
              " " +
              user.surname +
              ", your id number already exist, if its not you, please contact us",
            "error"
          );
        }
      });
  };

  triggerSnackbar = (message, variant) => {
    this.setState({
      snackbarMessage: message,
      snackbarVariant: variant,
      snackbarTrigger: true,
      submmiting: false,
      submmitingComment: false
    });
  };

  onDisclamerClose = response => {
    this.setState({
      disclaimerTriggered: false,
      disclaimerAgreed: response === "Agree"
    });
  };

  triggerSure = bibNumber => {
    this.setState({
      sureMessage: `Welcome to GGC5K,\nYour bib number is ${bibNumber}. \nThis is your number for all events. \nPlease print it to wear on the run. You will receive a confirmation e-mail in the next few days.`,
      sureDialogTriggered: true
    });
  };
  formatDate(date) {
    if (!date) date = new Date();
    return (
      date.getFullYear() + "/" + (date.getMonth() + 1) + "/" + date.getDate()
    );
  }

  render() {
    const { classes } = this.props;
    const genders = ["Male", "Female"];

    return (
      <React.Fragment>
        <CssBaseline />

        <CustomizedSnackbar
          message={this.state.snackbarMessage}
          trigger={this.state.snackbarTrigger}
          variant={this.state.snackbarVariant}
          onClose={this.onSnackbarClose}
        />

        <DisclaimerDialog
          open={this.state.disclaimerTriggered}
          onClose={response => this.onDisclamerClose(response)}
        />

        <FormDialog
          title={"Contact US"}
          open={this.state.contactFormTriggered || false}
          onClose={this.onContactFormClose}
          onSave={this.onSubmitComment}
          fields={[
            { id: "name", label: "Name", type: "text", required: true },
            {
              id: "email",
              label: "Email",
              type: "email",
              required: true
            },
            {
              id: "message",
              label: "Message",
              multiline: true,
              rows: 4,
              required: true
            }
          ]}
        />

        <SureDialog
          title="You have successfully registered to GGC5K!"
          message={this.state.sureMessage}
          onAgree={this.onSureClose}
          triggered={this.state.sureDialogTriggered}
          onAgreeText="Close"
        />

        <Grid
          container
          alignItems="center"
          alignContent="center"
          className={classes.gridContainer}
        >
          <Grid item md={12} className={classes.gridItem}>
            <Card className={classes.card}>
              <CardMedia
                component="img"
                alt="GGC"
                className={classes.media}
                height="140"
                image={cardImage}
                title="GGC"
              />
              <CardContent className={classes.cardContent}>
                <form autoComplete="off" id="registration-form">
                  <Grid container>
                    <Grid item xs={12}>
                      <TextField
                        required
                        id="firstName"
                        label="First name"
                        className={classes.textField}
                        onBlur={this.handleChange}
                        margin="normal"
                        variant="outlined"
                      />
                      <TextField
                        required
                        id="surname"
                        label="Surname"
                        className={classes.textField}
                        onBlur={this.handleChange}
                        margin="normal"
                        variant="outlined"
                      />
                      <TextField
                        required
                        id="phone"
                        label="Phone"
                        className={classes.textField}
                        onBlur={this.handleChange}
                        margin="normal"
                        variant="outlined"
                      />
                      <TextField
                        required
                        id="email"
                        label="Email"
                        type="email"
                        className={classes.textField}
                        onBlur={this.handleChange}
                        margin="normal"
                        variant="outlined"
                      />
                      <TextField
                        required
                        label="Omang/Passport"
                        id="idNumber"
                        className={classes.textField}
                        onBlur={this.handleChange}
                        margin="normal"
                        variant="outlined"
                      />
                      <MuiPickersUtilsProvider utils={MomentUtils}>
                        <KeyboardDatePicker
                          required
                          id="dob"
                          label="Date of Birth"
                          format={"DD/MM/YYYY"}
                          value={this.state.dob}
                          className={classes.textField}
                          onChange={this.handleDateChange}
                          margin="normal"
                          inputVariant="outlined"
                          helperText={
                            this.state.dob.fromNow().split(" ")[0] < 18 ? (
                              <span className={classes.redHelperText}>
                                We will send you an e-mail with a parental
                                consent form to be completed and returned before
                                approving the minor’s registration
                              </span>
                            ) : (
                              "Click on the year button to change the year."
                            )
                          }
                        />
                      </MuiPickersUtilsProvider>
                      <TextField
                        required
                        id="gender"
                        select
                        label="Gender"
                        className={classes.textField}
                        value={this.state.gender}
                        onChange={this.handleSelectChange("gender")}
                        SelectProps={{
                          MenuProps: {
                            className: classes.menu
                          }
                        }}
                        margin="normal"
                        variant="outlined"
                      >
                        {genders.map(option => (
                          <MenuItem key={option} value={option}>
                            {option}
                          </MenuItem>
                        ))}
                      </TextField>
                      <TextField
                        id="nationality"
                        select
                        label="Nationality"
                        className={classes.textField}
                        value={this.state.nationality}
                        onChange={this.handleSelectChange("nationality")}
                        SelectProps={{
                          native: true,
                          MenuProps: {
                            className: classes.menu
                          }
                        }}
                        margin="normal"
                        variant="outlined"
                      >
                        {nationalities.map(option => (
                          <option key={option} value={option}>
                            {option}
                          </option>
                        ))}
                      </TextField>
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        required
                        label="Emergency contact name"
                        id="ecName"
                        className={classes.textField}
                        onBlur={this.handleChange}
                        margin="normal"
                        variant="outlined"
                      />
                      <TextField
                        required
                        label="Emergency contact phone number"
                        id="ecPhone"
                        className={classes.textField}
                        onBlur={this.handleChange}
                        margin="normal"
                        variant="outlined"
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <FormGroup row>
                        <FormControlLabel
                          control={
                            <Checkbox
                              id="volunteer"
                              checked={this.state.volunteer}
                              onChange={this.handleCheckboxChange}
                              value="volunteer"
                            />
                          }
                          label={"I would like to occasionally volunteer"}
                        />
                      </FormGroup>
                    </Grid>
                    <Grid item xs={12}>
                      <FormGroup row>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={this.state.disclaimerAgreed}
                              onChange={() => this.disclaimerTrigger()}
                              value="indemnity"
                            />
                          }
                          label={
                            "I agree to the following terms and conditions"
                          }
                        />
                      </FormGroup>
                    </Grid>
                  </Grid>
                </form>
              </CardContent>
              <CardActions className={classes.cardActions}>
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.smallButton}
                  size="small"
                  onClick={this.openContactForm}
                >
                  Contact Us
                </Button>
                {this.state.submmiting ? (
                  <CircularProgress />
                ) : (
                  <Button
                    variant="contained"
                    color="secondary"
                    size="large"
                    className={classes.submitButton}
                    onClick={this.onSubmit}
                  >
                    Register
                  </Button>
                )}
              </CardActions>
            </Card>
          </Grid>
          <Grid item xs={12}>
            <Footer />
          </Grid>
        </Grid>
      </React.Fragment>
    );
  }
}

Register.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(Register);
